module.exports = __webpack_public_path__ + "static/media/workoutCalisthenics.171002e2.png";